import { useCallback, useEffect, useRef, useState } from 'react'
import { type Track } from './api.ts'
import { TrackList, type TrackListProps } from './TrackList.tsx'

interface PaginatedTrackListProps extends Omit<TrackListProps, 'hasMore' | 'loadingMore' | 'onLoadMore'> {
  tracks: Track[]
  hasMore: boolean
  loadMore: () => Promise<void>
}

export function PaginatedTrackList({
  tracks,
  hasMore,
  loadMore,
  ...trackListProps
}: PaginatedTrackListProps) {
  const [loadingMore, setLoadingMore] = useState(false)
  const isLoadingMoreRef = useRef(false)
  const hasMoreRef = useRef(hasMore)
  const loadMoreRef = useRef(loadMore)

  useEffect(() => {
    hasMoreRef.current = hasMore
  }, [hasMore])

  useEffect(() => {
    loadMoreRef.current = loadMore
  }, [loadMore])

  const handleLoadMore = useCallback(() => {
    if (!isLoadingMoreRef.current && hasMoreRef.current && loadMoreRef.current) {
      isLoadingMoreRef.current = true
      setLoadingMore(true)
      loadMoreRef.current().finally(() => {
        isLoadingMoreRef.current = false
        setLoadingMore(false)
      })
    }
  }, [])

  return (
    <TrackList
      {...trackListProps}
      tracks={tracks}
      hasMore={hasMore}
      loadingMore={loadingMore}
      onLoadMore={handleLoadMore}
    />
  )
}

